"use client";

import { EditProfilePage, ProfileLayout } from "@up/profile";

export default function ProfilePage() {
  return (
    <div className="slice-padding">
      <div className="mx-auto max-w-6xl px-4">
        <ProfileLayout title="Profile">
          <EditProfilePage />
        </ProfileLayout>
      </div>
    </div>
  );
}
